import React from 'react';
import { connect } from 'react-redux';
import { onSubmitActions } from 'redux-form-submit-saga';
import { reduxForm, Field, InjectedFormProps } from 'redux-form';
import { Alert, Row, Col, FormGroup, Label } from 'reactstrap';
import { compose } from 'redux';

import Input from '@/components/elements/Input';
import CustomFieldTextBox from '@/components/elements/CustomFieldTextBox';
import CustomFieldDropDown from '@/components/elements/CustomFieldDropDown';
import { CustomFieldType } from '@/types';
import { Trans } from '@lingui/macro';
import { ApplicationState } from '@/store';

import './CustomerForm.css';
import { withI18n } from '@lingui/react';

interface Props extends InjectedFormProps<any> {
    [key: string]: any;
}

interface OwnProps {
    anonymous?: boolean;
}

const validateEmail = (value: string) =>
    value && !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(value)
        ? 'Ange en giltig e-postadress'
        : undefined;
export class CustomerForm extends React.Component<Props> {
    render() {
        const { handleSubmit, error, company, anonymous, isLoggedIn, i18n } = this.props;

        const identityNumberPlaceholder = i18n._("identityNumberPlaceholder");

        return (
            <form onSubmit={handleSubmit}>
                {/*
                // @ts-ignore */}
                {company?.BookingSettings?.ShowPersonalIdentityNumber && (
                    <FormGroup>
                        <Field
                            className='form-component'
                            name='Customer.PersonalIdentityNumber'
                            component={Input}
                            label={<Trans id='identityNumber'></Trans>}
                            required
                            placeholder={identityNumberPlaceholder}
                        />
                    </FormGroup>
                )}
                <Row form>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                className="form-component"
                                name="Customer.Firstname"
                                component={Input}
                                label={<Trans id="firstname"></Trans>}
                                required
                            />
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup>
                            <Field
                                className="form-component"
                                name="Customer.Lastname"
                                component={Input}
                                label={<Trans id="lastname"></Trans>}
                                required
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <FormGroup>
                    <Field
                        className="form-component"
                        name="Customer.Phone"
                        component={Input}
                        label={<Trans id="phone"></Trans>}
                        required
                    />
                </FormGroup>
                <FormGroup style={{ display: `${isLoggedIn ? 'none' : undefined}` }}>
                    <Field
                        className="form-component"
                        name="Customer.Email"
                        disabled={!anonymous}
                        component={Input}
                        label={<Trans id="email"></Trans>}
                        required
                        type="email"
                        validate={validateEmail}
                    />
                </FormGroup>
                {company.BookingSettings.RequireCustomerPinCode && (
                    <FormGroup style={{ display: `${isLoggedIn ? 'none' : undefined}` }}>
                        <Field
                            className="form-component"
                            name="PinCode"
                            component={Input}
                            label={<Trans id="pinCode"></Trans>}
                            required
                            type="text"
                        />
                    </FormGroup>
                )}
                {company?.BookingSettings?.CustomerInvoiceAdressRequired ? <>
                    {/* TODO: make reusable component for form section heading */}
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                        <div style={{ flexGrow: 1 }}><hr /></div>
                        <small><Trans id="Customer.InvoiceAddress" /></small>
                        <div style={{ flexGrow: 1 }}><hr /></div>
                    </div>
                    <FormGroup>
                        <Field
                            className="form-component"
                            name="Customer.InvoiceAddress.InvoiceAddress1"
                            component={Input}
                            label={<Trans id="Customer.InvoiceAddress1" />}
                            required
                        />
                    </FormGroup>
                    <FormGroup>
                        <Field
                            className="form-component"
                            name="Customer.InvoiceAddress.InvoiceAddress2"
                            component={Input}
                            label={<Trans id="Customer.InvoiceAddress2" />}
                            required
                        />
                    </FormGroup>
                    <FormGroup className='form-group-flex'>
                        <Field
                            className="form-component"
                            name="Customer.InvoiceAddress.InvoicePostalCode"
                            component={Input}
                            label={<Trans id="Customer.InvoicePostalCode" />}
                            required
                        />
                        <div style={{ flexGrow: 1 }}>
                            <Field
                                className="form-component"
                                name="Customer.InvoiceAddress.InvoiceCity"
                                component={Input}
                                label={<Trans id="Customer.InvoiceCity" />}
                                required
                            />

                        </div>
                        <Field
                            className="form-component"
                            name="Customer.InvoiceAddress.InvoiceCountryCode"
                            component={(props: any) => (
                                <FormGroup>
                                    {props.label ? <Label>{props.label}</Label> : null}
                                    <select
                                        {...props}
                                        className="custom-select"
                                        defaultValue={props.input.value}
                                        onChange={props.input.onChange}
                                        onBlur={props.input.onBlur}
                                    >
                                        <option value={"SE"}>SE</option>
                                        <option value={"DK"}>DK</option>
                                        <option value={"FI"}>FI</option>
                                        <option value={"NO"}>NO</option>
                                    </select>
                                </FormGroup>
                            )}
                            label={<Trans id="Customer.InvoiceCountryCode" />}
                            required
                        />

                    </FormGroup>
                </> : null}
                {company.CustomerCustomFields &&
                    this.renderCustomerCustomFields(company.CustomerCustomFields)}
                {error && <Alert color="danger">{error}</Alert>}

            </form>
        );
    }

    renderCustomerCustomFields = (customFields: Array<CustomFieldType>) => {
        return [...customFields].sort((a, b) => (a.SortOrder ?? 0) - (b.SortOrder ?? 0)).map((customField) => {
            if (customField.DataType === 'TextBox') {
                return (
                    <CustomFieldTextBox
                        key={customField.Id}
                        customField={customField}
                        name={`CustomerCustomFields._${customField.Id}`}
                    />
                );
            }

            if (customField.DataType === 'DropDown') {
                return (
                    <CustomFieldDropDown
                        key={customField.Id}
                        customField={customField}
                        name={`CustomerCustomFields._${customField.Id}`}
                    />
                );
            }

            return false;
        });
    };
}

function mapStateToProps(state: ApplicationState, props: any) {
    const companyId = state.company.data?.Id;
    const companyCustomerCustomFields: any[] | undefined = state.company.data?.CustomerCustomFields;

    const customerCustomFields = state.user.data?.CompanyCustomers && state.user.data?.CompanyCustomers.find(c => c.CompanyId === companyId)?.CustomFieldValues
        ? state.user.data?.CompanyCustomers.find(c => c.CompanyId === companyId)?.CustomFieldValues
        : [];


    const customerProfile =
        state.createAccount.data
            ? {
                Firstname: state.createAccount.data.Firstname,
                Lastname: state.createAccount.data.Lastname,
                Email: state.createAccount.data.Email,
                Phone: state.createAccount.data.Phone,
            }
            : state.user.data
                ? state.user.data.CustomerProfile
                : {};

    const initialValues: any = {
        Customer: {
            ...customerProfile,
            InvoiceAddress: {
                InvoiceAddress1: '',
                InvoiceAddress2: '',
                InvoicePostalCode: '',
                InvoiceCity: '',
                InvoiceCountryCode: 'SE'
            }
        }
    };

    if (companyCustomerCustomFields) {
        companyCustomerCustomFields.forEach((customField: any) => {
            if (!initialValues["CustomerCustomFields"]) {
                initialValues["CustomerCustomFields"] = {};
            }
            initialValues["CustomerCustomFields"][`_${customField.Id}`] =
                customerCustomFields?.find(cf => cf.Id === customField.Id)?.Value
                    ? customerCustomFields?.find(cf => cf.Id === customField.Id)?.Value
                    : customField.DefaultValue;
        });
    }

    return {
        isLoggedIn: state.authenticate.isLoggedIn,
        company: state.company.data,
        form: 'customerForm',
        initialValues,
        onSubmitSuccess: () => {
            if (props.onSuccess) {
                props.onSuccess();
            }
        },
    };
}

export default compose(
    connect(mapStateToProps),
    withI18n(),
    reduxForm({
        enableReinitialize: true,
        onSubmit: onSubmitActions('BOOK', 'SAVE_BOOKING', 'FORM_ERROR'),
        destroyOnUnmount: false,
        keepDirtyOnReinitialize: true,
    })
)(CustomerForm) as React.ComponentType<OwnProps>;
